import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {ActionbarComponent} from '@catui/components/actionbar/actionbar.component';
import {AlertComponent} from '@catui/components/alert/alert.component';
import {AlertsComponent} from '@catui/components/alerts/alerts.component';
import {ButtonComponent} from '@catui/components/button/button.component';
import {FileUploadComponent} from '@catui/components/file-upload/file-upload.component';
import {FormStateInfoComponent} from '@catui/components/form-state-info/form-state-info.component';
import {IconSymbolComponent} from '@catui/components/icon-symbol/icon-symbol.component';
import {IconTextComponent} from '@catui/components/icon-text/icon-text.component';
import {PanelLinkedListComponent} from '@catui/components/panel-linked-list/panel-linked-list.component';
import {PanelListComponent} from '@catui/components/panel-list/panel-list.component';
import {PanelComponent} from '@catui/components/panel/panel.component';
import {SectionContentComponent} from '@catui/components/section-content/section-content.component';
import {SectionHeaderComponent} from '@catui/components/section-header/section-header.component';
import {TemplateDirective} from '@catui/directives/template/template.directive';
import {FileUploadModule} from 'ng2-file-upload';
import {ButtonModule, MenuModule, ProgressSpinnerModule, TreeModule} from 'primeng/primeng';
import {MainareaComponent} from './components/mainarea/mainarea.component';
import {PopupMenuComponent} from './components/popup-menu/popup-menu.component';
import { ProgressHeaderComponent } from './components/progress-header/progress-header.component';

const publicComponents = [
  SectionHeaderComponent,
  ProgressHeaderComponent,
  SectionContentComponent,
  ActionbarComponent,
  MainareaComponent,
  PopupMenuComponent,
  PanelComponent,
  FileUploadComponent,
  FormStateInfoComponent,
  PanelLinkedListComponent,
  PanelListComponent,
  TemplateDirective,
  AlertComponent,
  AlertsComponent,
  ButtonComponent,
];

const imports = [
  CommonModule,
  RouterModule,
  MenuModule,
  ButtonModule,
  TreeModule,
  FileUploadModule,
];
const declarations = [
  IconTextComponent,
  IconSymbolComponent,

  ...publicComponents,
];
const exportings = [...publicComponents];
const providers = [
];

@NgModule({
  imports: [
    imports,
    ProgressSpinnerModule
  ],
  declarations,
  providers,
  exports: exportings,
})
export class UIBaseModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/ui-base/ui-base.module.ts